import React from "react";
import { classnames } from "@culturehq/components";

import colorWipeImg from "images/animations/color wipe.svg";
import circularWipeImg from "images/animations/circular wipe.svg";
import fadeImg from "images/animations/fade.svg";
import flipIconImg from "images/animations/flip.svg";
import floatIconImg from "images/animations/float.svg";
import noneImg from "images/animations/none.svg";
import popIconImg from "images/animations/pop.svg";
import rotateSlideImg from "images/animations/rotate slide.svg";
import scaleImg from "images/animations/scale.svg";
import slideImg from "images/animations/slide.svg";
import spinImg from "images/animations/spin.svg";
import squashImg from "images/animations/squash.svg";
import textAppearImg from "images/animations/text/appear.svg";
import textCounterImg from "images/animations/text/counter.svg";
import textFlyImg from "images/animations/text/fly.svg";
import textRevealImg from "images/animations/text/reveal.svg";
import textScaleImg from "images/animations/text/scale.svg";
import textSlideImg from "images/animations/text/slide.svg";
import textSpinImg from "images/animations/text/spin.svg";
import textTypeWriterImg from "images/animations/text/typewriter.svg";
import textWaveImg from "images/animations/text/wave.svg";
import wipeImg from "images/animations/wipe.svg";

import styles from "./animation.module.scss";
import { ElementProps } from "./AnimationTypes";
import { ANIMATIONS } from "../../utils/constants";

const images = {
  [ANIMATIONS.BOUNCE]: "",
  [ANIMATIONS.CIRCULAR_WIPE]: "",
  [ANIMATIONS.COLOR_WIPE]: colorWipeImg,
  [ANIMATIONS.CIRCULAR_WIPE]: circularWipeImg,
  [ANIMATIONS.FADE]: fadeImg,
  [ANIMATIONS.FILM_ROLL]: "",
  [ANIMATIONS.FLIP]: flipIconImg,
  [ANIMATIONS.NONE]: noneImg,
  [ANIMATIONS.PAN]: "",
  [ANIMATIONS.ROTATE_SLIDE]: rotateSlideImg,
  [ANIMATIONS.SCALE]: scaleImg,
  [ANIMATIONS.SHIFT]: "",
  [ANIMATIONS.SLIDE]: slideImg,
  [ANIMATIONS.SPIN]: spinImg,
  [ANIMATIONS.SQUASH]: squashImg,
  [ANIMATIONS.STRIPE]: "",
  [ANIMATIONS.WIPE]: wipeImg,
  [ANIMATIONS.WIGGLE]: "",
  [ANIMATIONS.POP]: popIconImg,
  [ANIMATIONS.FLOAT]: floatIconImg,
  [ANIMATIONS.TEXT_APPEAR]: textAppearImg,
  [ANIMATIONS.TEXT_COUNTER]: textCounterImg,
  [ANIMATIONS.TEXT_FLY]: textFlyImg,
  [ANIMATIONS.TEXT_REVEAL]: textRevealImg,
  [ANIMATIONS.TEXT_SCALE]: textScaleImg,
  [ANIMATIONS.TEXT_SLIDE]: textSlideImg,
  [ANIMATIONS.TEXT_SPIN]: textSpinImg,
  [ANIMATIONS.TEXT_TYPEWRITER]: textTypeWriterImg,
  [ANIMATIONS.TEXT_WAVE]: textWaveImg
};

const AnimationElement: React.FC<ElementProps> = ({ type, label, isSelected, order, onClick }) => (
  <div
    className={styles.ElementContainer}
    onClick={onClick}
    style={{ order }}
  >
    <div className={classnames(styles.Element, styles[label], { [styles.selected]: isSelected })}>
      <img src={images[type]} alt={label} />
    </div>
    <span>{label}</span>
  </div>
);

export default AnimationElement;
